




























import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import Passenger from '../models/Passenger';
import Utility from '../models/Utility';

@Component({
  components: {}
})
export default class PassengerUtilities extends Vue {

  @Prop({ default: false }) private allowUserInput!: boolean;
  @Prop({ default: null }) private passenger!: Passenger;


  get utilities() {
      const utilityOptions = Passenger.utilities.map(u => new Utility(u.id, u.title));
      utilityOptions.forEach(u => u.selected = this.passenger.utilityIds.includes(u.id));
      return utilityOptions;        
  }

  utilityIconImageSrc(utilityId: number): string{
      const imageBasePath = '/frontend/utilities/';
      if (utilityId === 2){
          return imageBasePath + 'man-waving-arm-32' + '.png';
      } else {
          return imageBasePath + 'utility' + utilityId + '.png';
      }
  }

  utilityTitle(utilityId: number): string{
      const utility: Utility = Passenger.utilities.find((u: any) => u.id === utilityId);
      return utility 
          ? this.$i18n.translate("utility.title." + utility.title, utility.title) 
          : "Unknown utility";
  }

  onUtilityClick(utilityId: number) {
      this.passenger.toggleUtility(utilityId);
  }

}
